import {
  getObject,
} from "@surya-digital/leo-ts-types";
import { OpenEndedFieldV1, OpenEndedFieldV1DTO } from "./openEndedFieldV1";

export interface GridOpenEndedQuestionV1DTO {
  option: OpenEndedFieldV1DTO;
}

export class GridOpenEndedQuestionV1 {
  readonly isGridOpenEndedQuestionV1GridOpenEndedQuestionV1: boolean = true;

  readonly option: OpenEndedFieldV1;


  constructor(
  option: OpenEndedFieldV1
  ) {
    this.option = option;
  }

  static fromDTO(dto: GridOpenEndedQuestionV1DTO): GridOpenEndedQuestionV1 {
    const option = OpenEndedFieldV1.fromDTO(getObject(dto, "option", InvalidGridOpenEndedQuestionV1OptionError));
    return new GridOpenEndedQuestionV1(
      option
    );
  }

  toDTO(): GridOpenEndedQuestionV1DTO {
    const dto: GridOpenEndedQuestionV1DTO = {
        option: this.option.toDTO()
    };
    return dto;
  }
  }

GridOpenEndedQuestionV1.prototype.toString = function toString(): string {
  return `GridOpenEndedQuestionV1(option='${this.option}')`;
};

export class InvalidGridOpenEndedQuestionV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridOpenEndedQuestionV1Error";
  }
}
export class InvalidGridOpenEndedQuestionV1OptionError extends InvalidGridOpenEndedQuestionV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridOpenEndedQuestionV1OptionError";
  }
}
